<template>
  <BackLastPage title="我的收货地址" />
  <van-address-list
    class="addressList"
    v-model="currentAddressId"
    :list="addressList"
    default-tag-text="默认"
    @select="selectAddress"
    @add="addAddress"
    @edit="editAddress"
  />
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { onBeforeRouteLeave, useRouter } from 'vue-router'
import { getAddressList, updateAddressInfo } from '@/api/profile'
import BackLastPage from '@/components/common/BackLastPage.vue'

export default {
  components: {
    BackLastPage
  },

  setup() {
    const router = useRouter()

    const state = reactive({
      originalAddressId: '',
      currentAddressId: '',
      addresses: [],
      addressList: []
    })

    onBeforeRouteLeave(async () => {
      // 判断默认地址在离开页面时是否改变
      if (state.originalAddressId === state.currentAddressId) return

      await updateAddressInfo({ id: state.currentAddressId, isDefault: 1 })
    })

    onMounted(async () => {
      const { addresses } = await getAddressList()
      state.addresses = addresses

      state.addressList = addresses
        // 过滤不合理的地址
        .filter(item => item.recipient && item.mobile)
        // 转换地址格式
        .map(item => {
          // 获取默认地址
          if (item.isDefault) {
            state.originalAddressId = item.id
            state.currentAddressId = item.id
          }

          return {
            id: item.id,
            name: item.recipient,
            tel: item.mobile,
            address: `${item.provinceName}/${item.cityName} ${item.address}`,
            isDefault: item.isDefault
          }
        })
    })

    const selectAddress = item => {
      state.currentAddressId = item.id
      // 设置选中地址为默认地址
      state.addressList = state.addressList.map(a => (a.id === item.id ? { ...a, isDefault: 1 } : { ...a, isDefault: 0 }))
    }

    const editAddress = item => router.push({ path: '/addressEdit', query: { id: item.id } })

    const addAddress = () => router.push({ path: '/addressEdit' })

    return {
      ...toRefs(state),
      selectAddress,
      editAddress,
      addAddress
    }
  }
}
</script>

<style lang="scss" scoped>
.navBar {
  height: 40px;
}
.addressList {
  :deep(.van-radio__icon--checked .van-icon) {
    background-color: #3088c5;
    border-color: #3088c5;
  }
  :deep(.van-tag--danger) {
    background-color: #3088c5;
  }
  :deep(.van-button--danger) {
    color: #fff;
    background-color: #3088c5;
    border: 0.02667rem solid #3088c5;
  }
}
</style>
